import {CustomDiv} from '../../lib/react';

export const Spacing: CustomDiv<{height?: number; width?: number}> = ({
  width = '100%',
  height = '100%',
  style = {},
  ...rest
}) => <div style={{width, height, flexShrink: 0, ...style}} {...rest} />;
